export const apiConfig = {
  custompages: {
    endpoint: "v1/content/code/pages-url",
    method: "get",
    key: "params",
    labelKey: "label",
    valueKey: "value",
  },
  podcast: {
    endpoint: "v1/podcast/list",
    method: "post",
    key: "podcastList",
    labelKey: "heading",
    valueKey: "podcast_url",
  },
  video: {
    endpoint: "v1/podcast/list",
    method: "post",
    key: "podcastList",
    labelKey: "heading",
    valueKey: "podcast_url",
  },
  news: {
    endpoint: "v1/news/list",
    method: "post",
    key: "newsList",
    labelKey: "heading",
    valueKey: "external_link",
  },
  blog: {
    endpoint: "v1/blog/list",
    method: "post",
    key: "blogList",
    labelKey: "heading",
    valueKey: "url",
  },
  job: {
    endpoint: "v1/job/list",
    method: "post",
    key: "jobList",
    labelKey: "name",
    valueKey: "url",
  },
  announcement: {
    endpoint: "v1/announcement/list",
    method: "post",
    key: "announcementList",
    labelKey: "heading",
    valueKey: "thumbnail_url",
  },
};
